"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { ShieldCheck, Users, Award, CircleCheck } from "lucide-react";
const metrics = [{
  value: "1500+",
  label: "عميل يثق بنا",
  icon: <Users className="w-8 h-8 text-accent" />
}, {
  value: "20+",
  label: "عام من الخبرة",
  icon: <Award className="w-8 h-8 text-accent" />
}, {
  value: "100%",
  label: "مواد آمنة ومعتمدة",
  icon: <ShieldCheck className="w-8 h-8 text-accent" />
}, {
  value: "50+",
  label: "فريق عمل متخصص",
  icon: <CircleCheck className="w-8 h-8 text-accent" />
}];
const partners = [{
  name: "Ministry of Health",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1661713/img/logo_ministry_health.png"
}, {
  name: "Municipality Riyadh",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1661713/img/logo_riyadh_municipality.png"
}, {
  name: "SFDA",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1661713/img/logo_sfda_pest.png"
}, {
  name: "Environment Authority",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1661713/img/logo_environment_agency.png"
}, {
  name: "ISO Certified",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1661713/img/logo_iso_certification.png"
}, {
  name: "Safety Standards",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1661713/img/logo_safety_standard.png"
}];
export default function ImpactStatisticsPartners() {
  const duplicatedPartners = [...partners, ...partners, ...partners];
  return <section data-section-id="249053" id="اعتماداتنا-وأرقامنا" className="bg-primary text-white relative overflow-hidden py-24 lg:py-32" dir="rtl">
      <style dangerouslySetInnerHTML={{
      __html: `
          @keyframes marquee-horizontal {
            0% { transform: translateX(0); }
            100% { transform: translateX(100%); }
          }
          .animate-marquee-rtl {
            animation: marquee-horizontal 40s linear infinite;
          }
        `
    }} />

      {}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none">
        <div className="absolute -top-24 -right-24 w-[50%] sm:w-[60%] lg:w-96 h-[50%] sm:h-[60%] lg:h-96 bg-accent/10 rounded-full blur-3xl" />
        <div className="absolute -bottom-24 -left-24 w-[50%] sm:w-[60%] lg:w-96 h-[50%] sm:h-[60%] lg:h-96 bg-secondary rounded-full blur-3xl" />
      </div>

      <div className="page-container relative z-10">
        <div className="flex flex-col gap-16 lg:gap-24">
          {}
          <div className="max-w-3xl mx-auto text-center">
            <span className="inline-block px-4 py-1.5 mb-6 text-sm font-bold tracking-wider uppercase bg-accent text-primary rounded-full">
              الاعتمادات والأرقام
            </span>
            <h2 className="text-4xl lg:text-5xl font-bold text-white mb-6 font-primary">
              شراكاتنا واعتماداتنا الدولية والمحلية
            </h2>
            <p className="text-white/80 text-lg leading-relaxed font-primary">
              نعمل وفق أعلى معايير السلامة والجودة العالمية، ومعتمدون من كافة الجهات الرقابية في المملكة لضمان أفضل خدمة لعملائنا.
            </p>
          </div>

          {}
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3 sm:gap-4 lg:gap-6">
            {metrics.map((metric, i) => <div key={i} data-index={i} className="flex flex-col items-center text-center p-4 sm:p-6 lg:p-8 rounded-lg bg-secondary/40 border border-white/10 backdrop-blur-md shadow-lg transition-all duration-300 hover:translate-y-[-8px] hover:border-accent/30">
                <div className="mb-6 p-4 rounded-full bg-white/5 border border-white/10">
                  {metric.icon}
                </div>
                <h3 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-accent mb-2 font-primary">
                  {metric.value}
                </h3>
                <p className="text-base font-medium text-white/70 uppercase tracking-wide font-primary">
                  {metric.label}
                </p>
              </div>)}
          </div>

          {}
          <div className="relative w-full">
            <div className="text-center mb-12">
              <p className="text-white/50 font-bold text-xs uppercase tracking-[0.3em] font-primary">
                شركاء النجاح المعتمدون
              </p>
            </div>
            
            <div className="relative overflow-hidden py-10 bg-white/5 rounded-lg border border-white/5 backdrop-blur-sm">
              {}
              <div className="absolute inset-y-0 left-0 w-24 bg-gradient-to-r from-primary to-transparent z-10 pointer-events-none" />
              <div className="absolute inset-y-0 right-0 w-24 bg-gradient-to-l from-primary to-transparent z-10 pointer-events-none" />
              
              <div className="flex w-max animate-marquee-rtl hover:[animation-play-state:paused]">
                {duplicatedPartners.map((partner, i) => <div key={i} data-index={i} className="w-48 flex-shrink-0 px-8 flex items-center justify-center group">
                    <img src={partner.logo} data-wvc-srcset={`${partner.logo}-wvc-srcset`} data-wvc-sizes={`${partner.logo}-wvc-sizes`} alt={`${partner.name} logo`} className="max-h-12 w-auto object-contain brightness-0 invert opacity-40 transition-all duration-500 ease-in-out group-hover:opacity-100 group-hover:scale-110" loading="lazy" />
                  </div>)}
              </div>
            </div>
          </div>

          {}
          <div className="flex justify-center mt-4">
            <Button asChild className="bg-accent hover:bg-accent/90 text-primary font-bold px-10 py-6 rounded-full text-lg shadow-xl transition-transform hover:scale-105 active:animate-click">
              <Link to="#contact">
                اطلب الخدمة الآن
              </Link>
            </Button>
          </div>
        </div>
      </div>
    </section>;
}